<template>
  <div>
    <div>
      <div class="d-flex align-items-center mb-3">
        <button @click.prevent="backtolist" class="btn btn-outline-primary">&lt; Return to list</button>
        <h3 class="mb-0 ms-4" v-if="material_id > 0">{{material_heading}}</h3>
        <h3 class="mb-0 ms-4" v-if="material_id < 0">Add Material</h3>
      </div>
      <div class="card border-0 mx-0 px-0 py-10 col-12">
        <div class="card-body">
          <form autocomplete="off" @submit.stop.prevent>
            <div class="row mb-3">
              &nbsp;
            </div>
            <div class="row mb-3 align-items-center">
              <label class="col-2 col-form-label">Heading</label>
              <div class="col-6">
                <input  
                  id="material_heading" 
                  :class="['form-control', {'is-invalid': material_heading_valid === false, 'is-valid': material_heading_valid === true}]"
                  v-model="material_heading"
                  @change="savefield('g_elearning_materials',material_id,'material_heading',material_heading)" 
                  autocomplete="off"
                />
                <div class="invalid-feedback">Material heading cannot be blank</div>
              </div>
            </div>

            <div class="row mb-3 align-items-center">
              <label class="col-2 col-form-label">Material file</label>
              <div class="col-10">
                {{material_filename}}
              </div>
            </div>

            <div class="row mb-3 align-items-center">
              <label class="col-2 col-form-label">Upload new material file</label>
              <div class="col-6">
                <input
                  type="file"
                  :class="['form-control', {'is-invalid': material_file_valid === false, 'is-valid': material_file_valid === true}]"
                  ref="material_file"
                  @change="handleFileUpload"
                />
                <div class="invalid-feedback">Material file cannot be blank</div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 mt-4">
                <button 
                  v-if="material_id < 1" 
                  @click.prevent="material_create" 
                  class="btn btn-primary"
                >
                  Save New Material
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  name: 'LearningMaterial',
  created() {
    this.material_get();
  },
  data: function() {
    return {
      material_heading: '',
      material_heading_valid: null,
      material_filename: '',
      material_file: null,
      material_file_valid: null,
      loading: true,
      uploading: false,
    }
  },
  computed: {
    material_id: {
      get() {
        return this.$store.state.currentelearningmaterial_id;
      }
    },
  },
  watch: {
    material_id: function() {
      this.material_get()
    }
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.material_file = file;
        this.materialfile_save();
      }
    },
    checkform() {
      var formok = true;
      this.material_heading_valid = true;
      if (this.material_heading == '') { 
        this.material_heading_valid = false; 
        formok = false;
      }
      this.material_file_valid = true;
      if (this.material_file == null && this.material_id < 1) {
        this.material_file_valid = false;
        formok = false;
      }
      return formok;
    },
    materialfile_save() {
      if (this.$store.state.currentelearningmaterial_id > 0) {
        this.uploading = true;
        const fd = new FormData();
        fd.append('material_id',this.$store.state.currentelearningmaterial_id);
        fd.append('material_file',this.material_file);
        this.$store.dispatch('elearningmaterialfile_save', fd)
        .then(() => {
          this.uploading = false;
          this.material_get();
        });
      }
    },
    material_create() {
      if (this.checkform()) {
        const fd = new FormData();
        fd.append('material_heading',this.material_heading);
        fd.append('material_file',this.material_file);
        this.$store.dispatch('elearningmaterial_create', fd)
        .then((resp) => {
          var material_id = resp.data.id;
          this.$store.dispatch('elearningmaterial_setcurrent',{ material_id: material_id })
          .then(() => {
            this.material_get();
          });
        });
      }
    },
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 ) {
        if (this.checkform()) {
          var record = {
            id: id,
            [fieldname]: value,
          }
          this.$store.dispatch('field_save', { tablename: tablename,record: record })
          .then(() => {
            this.$store.dispatch('elearningmaterialchanged_set',{ material_id: this.material_id });
          });
        }
      }
    },
    material_get() {
      this.material_heading = '';
      this.material_file = null;
      this.material_filename = '';
      this.labels = [];
      if (this.material_id > 0) {
        this.$store.dispatch('elearningmaterial_fetch', { material_id: this.material_id })
        .then((resp) => {
          this.material_heading = resp.data.material_heading;
          this.material_filename = resp.data.material_filename;
          this.loading = false;
        });
      }
    },
    backtolist() {
      this.$store.dispatch('elearningmaterial_setcurrent',{ material_id: 0 })
    },
  }
}
</script>
<style>
</style>
